/**
 * アウトプット画面の表示ヘルパー。
 *
 * Pt の 0 は「0ptで見積もり済み」ではなく**未見積もり**（起票時の初期値）なので、
 * 空欄と同じくダッシュで見せる。0 と表示すると見積もり済みに見えてしまう。
 */
/** @graph-connects none */
export function formatPt(pt: number | null): string {
  return pt === null || pt === 0 ? '—' : pt.toLocaleString();
}

/** Backlog 課題ページのベースURL */
/** @graph-connects none */
const BACKLOG_ISSUE_BASE_URL = 'https://air-closet.backlog.jp/view';

/**
 * 課題キーから Backlog のリンクを組み立てる。
 *
 * @graph-stack quality-atelier
 * @graph-domain Quality
 * @graph-business 課題キーからBacklog課題ページのURLを組み立てる
 * @graph-connects none
 */
export function backlogIssueUrl(issueKey: string): string {
  return `${BACKLOG_ISSUE_BASE_URL}/${issueKey}`;
}
